<template>
  <div class="views-bulletin-layout">
    <div class="views-bulletin-layout-wrapper">
      <div class="views-bulletin-layout__header">
        <div class="views-bulletin-layout__header-left">
          {{ $route.params.id !== undefined ? '編輯' : '新增' }}看板
        </div>
        <div class="views-bulletin-layout__header-right">
          *為必填
        </div>
      </div>

      <div class="views-bulletin-layout__body">
        <el-form
          ref="form"
          class="views-bulletin-layout__body-form"
          :model="form"
          :rules="rules"
          status-icon
          :show-message="false"
          label-position="top"
          size="medium"
        >
          <el-form-item
            label="看板名稱"
            prop="name"
            class="views-bulletin-layout__body-form-item"
          >
            <el-input
              v-model="form.name"
              placeholder="請輸入看板名稱"
              maxlength="20"
              class="views-bulletin-layout__body-name__input"
              show-word-limit
            />
            <template>
              <span>看板名稱限 20 個字元</span>
            </template>
          </el-form-item>

          <el-form-item
            prop="theme"
            class="views-bulletin-layout__body-form-item"
          >
            <div class="views-bulletin-layout__body-form-item__label">
              <div class="views-bulletin-layout__body-form-item__label-title">
                主題背景
              </div>
            </div>
            <div class="views-bulletin-layout__body-form-item__theme-wrapper">
              <div>
                <el-radio-group v-model="form.theme">
                  <div class="views-bulletin-layout__body-form-item__theme">
                    <div class="views-bulletin-layout__body-form-item__theme-wrapper">
                      <el-radio :label="1">
                        淺色
                      </el-radio>
                      <img
                        src="@/assets/img/Bulletin/theme-light.png"
                        class="views-bulletin-layout__body-form-item__theme-image"
                        alt="淺色樣式預覽"
                        @click="setTheme(1)"
                      >
                    </div>
                    <div
                      class="views-bulletin-layout__body-form-item__theme-wrapper views-bulletin-layout__body-form-item__theme-wrapper-margin"
                    >
                      <el-radio :label="2">
                        深色
                      </el-radio>
                      <img
                        src="@/assets/img/Bulletin/theme-dark.png"
                        class="views-bulletin-layout__body-form-item__theme-image"
                        alt="深色樣式預覽"
                        @click="setTheme(2)"
                      >
                    </div>
                    <div class="views-bulletin-layout__body-form-item__theme-wrapper">
                      <el-radio :label="3">
                        社區 (請提供智生活設定)
                      </el-radio>
                      <img
                        src="@/assets/img/Bulletin/theme-community.png"
                        class="views-bulletin-layout__body-form-item__theme-image"
                        alt="社區樣式預覽"
                        @click="setTheme(3)"
                      >
                    </div>
                  </div>
                </el-radio-group>
              </div>
            </div>
          </el-form-item>

          <div class="views-bulletin-layout__body-form-item__layout">
            <div class="views-bulletin-layout__body-form-item__label">
              <div class="views-bulletin-layout__body-form-item__label-title">
                選擇版型
              </div>
              <div class="views-bulletin-layout__body-form-item__label-hint">
                需選擇 1 項
              </div>
            </div>
            <el-tabs v-model="activeTabName">
              <el-tab-pane
                label="橫式"
                name="horizontal"
              >
                <div class="views-bulletin-layout__body-category-filter-wrapper">
                  <div class="views-bulletin-layout__body-category-filter__title">
                    依下方任一條件搜尋
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__subtitle">
                    固定資訊：社區名稱、日期時間、天氣、智生活服務、公告、跑馬燈
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__select-wrapper">
                    <div class="views-bulletin-layout__body-category-filter__label">
                      支援內容
                    </div>
                    <el-select
                      v-model="form.filterCategoryContent"
                      class="views-bulletin-layout__body-category-filter__input"
                      multiple
                      filterable
                      placeholder="請選擇"
                    >
                      <el-option
                        v-for="(item, index) in categoryContent"
                        :key="index"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__hint">
                    ※ 可以選取多個選項
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__button-wrapper">
                    <el-button
                      type="primary"
                      round
                      icon="icon-search"
                      @click="searchCategory"
                    >
                      查詢
                    </el-button>
                    <el-button
                      round
                      @click="clearSearchCategory"
                    >
                      清除條件
                    </el-button>
                  </div>
                </div>
                <el-form-item prop="category">
                  <div
                    v-for="item in categoryListHorizontal"
                    :key="item.Id"
                    class="views-bulletin-layout__body-preview-wrapper views-bulletin-layout__body-preview-wrapper--horizontal"
                    :class="{ 'views-bulletin-layout__body-preview--selected': form.category === item.Id }"
                    @click="selectCategory(item)"
                  >
                    <div class="views-bulletin-layout__body-preview-image-wrapper">
                      <img
                        class="views-bulletin-layout__body-preview-image--horizontal"
                        :src="item.PreviewImageUrl"
                        alt="橫式預覽圖片"
                      >
                      <img
                        class="views-bulletin-layout__body-preview-image-magnifier"
                        src="@/assets/img/Bulletin/magnifier-icon.svg"
                        alt="放大鏡"
                        @click.stop="imagePreview(item.PreviewImageUrl)"
                      >
                    </div>
                    <div class="views-bulletin-layout__body-preview-title-wrapper">
                      <div class="views-bulletin-layout__body-preview-title">
                        {{ item.Name }}
                      </div>
                      <div class="views-bulletin-layout__body-preview-subtitle">
                        {{ item.ContentTypes.join("、") }}
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-tab-pane>
              <el-tab-pane
                label="直式"
                name="vertical"
              >
                <div class="views-bulletin-layout__body-category-filter-wrapper">
                  <div class="views-bulletin-layout__body-category-filter__title">
                    依下方任一條件搜尋
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__subtitle">
                    固定資訊：社區名稱、日期時間、天氣、智生活服務、公告、跑馬燈
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__select-wrapper">
                    <div class="views-bulletin-layout__body-category-filter__label">
                      支援內容
                    </div>
                    <el-select
                      v-model="form.filterCategoryContent"
                      class="views-bulletin-layout__body-category-filter__input"
                      multiple
                      filterable
                      placeholder="請選擇"
                    >
                      <el-option
                        v-for="(item, index) in categoryContent"
                        :key="index"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__hint">
                    ※ 可以選取多個選項
                  </div>
                  <div class="views-bulletin-layout__body-category-filter__button-wrapper">
                    <el-button
                      type="primary"
                      round
                      icon="icon-search"
                      @click="searchCategory"
                    >
                      查詢
                    </el-button>
                    <el-button
                      round
                      @click="clearSearchCategory"
                    >
                      清除條件
                    </el-button>
                  </div>
                </div>
                <el-form-item prop="category">
                  <div
                    v-for="item in categoryListVertical"
                    :key="item.Id"
                    class="views-bulletin-layout__body-preview-wrapper views-bulletin-layout__body-preview-wrapper--vertical"
                    :class="{ 'views-bulletin-layout__body-preview--selected': form.category === item.Id }"
                    @click="selectCategory(item)"
                  >
                    <div class="views-bulletin-layout__body-preview-image-wrapper">
                      <img
                        class="views-bulletin-layout__body-preview-image--vertical"
                        :src="item.PreviewImageUrl"
                        alt="直式預覽圖片"
                      >
                      <img
                        class="views-bulletin-layout__body-preview-image-magnifier"
                        src="@/assets/img/Bulletin/magnifier-icon.svg"
                        alt="放大鏡"
                        @click.stop="imagePreview(item.PreviewImageUrl)"
                      >
                    </div>
                    <div class="views-bulletin-layout__body-preview-title-wrapper">
                      <div class="views-bulletin-layout__body-preview-title">
                        {{ item.Name }}
                      </div>
                      <div class="views-bulletin-layout__body-preview-subtitle">
                        {{ item.ContentTypes.join("、") }}
                      </div>
                    </div>
                  </div>
                </el-form-item>
              </el-tab-pane>
            </el-tabs>
          </div>
        </el-form>
      </div>

      <div class="views-bulletin-layout__footer">
        <el-button
          :disabled="isSubmitting"
          round
          @click="goPageBulletin"
        >
          取消
        </el-button>
        <el-button
          type="primary"
          :disabled="isSubmitting"
          round
          @click="submitForm"
        >
          送出
        </el-button>
      </div>

      <el-dialog
        class="views-bulletin-layout__dialog"
        width="50%"
        title="版型預覽"
        :visible.sync="isDialogVisible"
      >
        <div class="views-bulletin-layout__dialog__image-wrapper">
          <img
            :src="dialogImage"
            class="views-bulletin-layout__dialog__image"
            alt="大型預覽圖片"
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isSubmitting: false,
      activeTabName: 'horizontal',
      form: {
        name: '',
        theme: 1,
        category: '',
        filterCategoryContent: []
      },
      rules: {
        name: [
          { required: true, message: '', trigger: 'blur' },
          { max: 20, message: '', trigger: 'blur' }
        ],
        theme: [{ required: true, message: '', trigger: 'change' }],
        category: [{ required: true, message: '', trigger: 'change' }]
      },
      categoryList: [],
      categoryListHorizontal: [],
      categoryListVertical: [],
      categoryContent: [], // ['社區名稱', '日期時間', '天氣', '智生活服務', '公告圖片', '公告列表', '影片', '跑馬燈', 'BA資訊', '包裹通知' ]
      isDialogVisible: false,
      dialogImage: ''
    }
  },
  mounted () {
    this.initPage()
  },
  beforeDestroy () {
  },
  methods: {
    async initPage () {
      try {
        if (this.$route.params.id) await this.getList()
        await this.getCategoryList()
        this.filterCategoryList()
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    async getList () {
      try {
        const queryPath = { id: this.$route.params.id }
        const { data } = await apiBulletin.getLayout(queryPath)
        this.form.name = data.Name
        this.form.theme = data.BackgroundImageTypeID
        this.form.category = data.ReferenceID
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    async getCategoryList () {
      try {
        const { data } = await apiBulletin.getLayoutCategoryList()
        const changelessCategoryContent = ['社區名稱', '智生活服務', '日期時間', '天氣', '跑馬燈', '公告列表', '公告圖片']
        this.categoryList = data
        this.categoryList.forEach(e => e.Name = e.Name.toUpperCase())
        console.log('this.categoryList', this.categoryList)
        this.categoryContent = [...new Set(this.categoryList.map(e => e.ContentTypes).reduce((a, b) => a.concat(b)))].filter(e => !changelessCategoryContent.includes(e))
        console.log('this.categoryContent', this.categoryContent)
      } catch (error) {
        console.log('error', error)
        this.$message.error('伺服器發生錯誤')
      }
    },
    setTheme (theme) {
      this.form.theme = theme
    },
    searchCategory () {
      const content = this.form.filterCategoryContent

      if (this.categoryList.length === 0) return

      if (content.length !== 0) {
        this.categoryListHorizontal = this.categoryList.filter(e => content.every(v => e.ContentTypes.includes(v)) && e.ModeID === 2)
        this.categoryListVertical = this.categoryList.filter(e => content.every(v => e.ContentTypes.includes(v)) && e.ModeID === 1)
      }
    },
    clearSearchCategory () {
      this.form.filterCategoryContent = []
      this.filterCategoryList()
    },
    filterCategoryList () {
      if (this.categoryList.length > 0) {
        this.categoryListHorizontal = this.categoryList.filter(e => e.ModeID === 2)
        this.categoryListVertical = this.categoryList.filter(e => e.ModeID === 1)
        console.log('this.form.category', this.form.category)
        console.log('this.categoryList', this.categoryList)
        if (this.form.category) {
          const selectCategory = this.categoryList.find(e => e.Id === this.form.category)
          console.log('selectCategory', selectCategory)
          if (selectCategory.ModeID === 1) this.activeTabName = 'vertical'
        }
      }
    },
    selectCategory (item) {
      console.log('selectCategory', item)
      this.form.category = item.Id
      this.$refs.form.clearValidate('category')
    },
    imagePreview (url) {
      console.log('imagePreview', url)
      this.isDialogVisible = true
      this.dialogImage = url
    },
    goPageBulletin () {
      this.$router.push({ name: 'BulletinIndex' })
    },
    submitForm () {
      this.isSubmitting = true
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            console.log('this.form', this.form)
            const queryPath = { id: this.$route.params.id }
            const params = {
              name: this.form.name,
              backgroundImageTypeID: this.form.theme,
              referenceID: this.form.category
            }
            if (this.$route.params.id !== undefined) {
              await apiBulletin.updateLayout(queryPath, params)
              this.$message.success('編輯看板成功')
            } else {
              await apiBulletin.newLayout(params)
              this.$message.success('新增看板成功')
            }
            this.goPageBulletin()
          } catch (error) {
            this.$message.error('伺服器發生錯誤')
            console.log('error', error)
          } finally {
            this.isSubmitting = false
          }
        } else {
          this.isSubmitting = false
          if (this.form.name && this.form.theme && !this.form.category) {
            return this.$alert('請選擇版型', '錯誤', {
              confirmButtonText: '確定',
              type: 'error',
              callback: action => {}
            })
          }
          this.$message.error('請重新確認輸入內容')
          window.scrollTo({ top: 0, behavior: 'smooth' })
          return false
        }
      })
    }
  }
}
</script>

<style lang="sass">

.views-bulletin-layout
  width: 100%
  height: 100%

.views-bulletin-layout-wrapper
  width: 1140px
  margin: 50px auto 10px auto
  padding: 30px
  color: $mainFontColor
  background-color: $white
  box-sizing: border-box
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1)
  border-radius: $pageBorderRadius

.views-bulletin-layout__header
  display: flex
  justify-content: space-between
  align-items: center

.views-bulletin-layout__header-left
  color: $mainFontColor
  font-weight: bold
  font-size: map-get($fontSize,xx-large)

.views-bulletin-layout__header-right
  color: #f00 // src/views/News/NewsEdit .tips

.views-bulletin-layout__body
  display: flex
  justify-content: center
  margin: 30px 0
  width: 100%
  box-sizing: border-box

.views-bulletin-layout__body-form
  width: 100%
  max-width: 600px
  margin: 0 auto

.views-bulletin-layout__body-form-item
  width: 600px

.views-bulletin-layout__body-form .el-form-item
  margin-bottom: 60px

.views-bulletin-layout__body-form .el-form-item__label
  font-size: 20px
  font-weight: bold

.views-bulletin-layout__body-name__input
  width: 600px

.views-bulletin-layout__body-name__input .el-input__inner
  padding-right: 85px

.views-bulletin-layout__body-form-item__theme-wrapper
  display: flex
  flex-direction: column

.views-bulletin-layout__body-form-item__theme
  display: flex
  margin-top: 10px

.views-bulletin-layout__body-form-item__theme-wrapper-margin
  margin: 0 12px

.views-bulletin-layout__body-form-item__theme-image
  width: 192px
  margin-top: 8px
  cursor: pointer

.views-bulletin-layout__body-form-item__label
  display: flex
  justify-content: space-between
  align-items: center
  height: 20px
  padding-bottom: 10px

.views-bulletin-layout__body-form-item__label-title
  font-size: 20px
  font-weight: bold

.views-bulletin-layout__body-form-item__label-title::before
  content: '*'
  color: #c44536
  margin-right: 4px

.views-bulletin-layout__body-form-item__label-hint
  display: flex
  justify-content: center
  align-items: center
  color: $white
  background: $warnColor
  border-radius: 2px
  padding: 4px 8px
  font-size: 13px
  line-height: 18px

.views-bulletin-layout__body-form-item__layout .el-tabs__header
  margin: 0

.views-bulletin-layout__body-form-item__layout > .el-tabs.el-tabs--top
  width: 100%

  & > .el-tabs__content
    overflow: initial
    position: initial

  .el-tab-pane .el-form-item
    width: 100%

    .el-form-item__content
      width: 100%
      display: flex
      flex-wrap: wrap
      gap: 18px
      margin-top: 18px

      &::before
        display: none

.views-bulletin-layout__body-category-filter-wrapper
  width: 100%
  box-sizing: border-box
  background-color: $bgDark3
  padding: 8px 16px 16px 16px

.views-bulletin-layout__body-category-filter__title
  font-size: 15px
  line-height: 21px
  font-weight: bold
  color: $mainFontColor

.views-bulletin-layout__body-category-filter__subtitle
  font-size: 13px
  line-height: 18px

.views-bulletin-layout__body-category-filter__select-wrapper
  display: flex
  align-items: center
  margin-top: 16px
  font-size: 15px
  line-height: 21px

.views-bulletin-layout__body-category-filter__label
  min-width: 80px

.views-bulletin-layout__body-category-filter__input
  width: 100%

.views-bulletin-layout__body-category-filter__input .el-input__inner
  padding-right: 30px

.views-bulletin-layout__body-category-filter__hint
  margin-top: 4px
  margin-left: 80px
  font-size: 13px
  line-height: 18px
  color: $dangerColor

.views-bulletin-layout__body-category-filter__button-wrapper
  text-align: right
  margin-top: 10px

.views-bulletin-layout__body-preview-wrapper
  width: 48%
  display: flex
  flex-direction: column
  box-sizing: border-box
  cursor: pointer
  box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.2)
  border-radius: $pageBorderRadius
  padding: 18px 12px 24px 12px

.views-bulletin-layout__body-preview-wrapper--horizontal
  min-height: 350px

.views-bulletin-layout__body-preview-wrapper--vertical
  min-height: 410px

.views-bulletin-layout__body-preview--selected
  color: $mainColor
  outline: solid 4px $mainColor

.views-bulletin-layout__body-preview-image-wrapper
  position: relative
  width: 100%
  display: flex
  justify-content: center
  margin-bottom: 32px

.views-bulletin-layout__body-preview-image-magnifier
  position: absolute
  right: 0px
  bottom: 0px

.views-bulletin-layout__body-preview-image--horizontal
  width: 240px
  height: 180px
  border-radius: $pageBorderRadius
  object-fit: contain

.views-bulletin-layout__body-preview-image--vertical
  width: 180px
  height: 240px
  border-radius: $pageBorderRadius
  object-fit: contain

.views-bulletin-layout__body-preview-title-wrapper
  display: flex
  flex-direction: column
  justify-content: center

.views-bulletin-layout__body-preview-title
  align-items: center
  font-size: 20px
  font-weight: bold
  color: $mainFontColor
  margin-bottom: 12px

.views-bulletin-layout__body-preview-subtitle
  align-items: center
  font-size: 16px
  color: $subFontColor
  line-height: 1.5

.views-bulletin-layout__footer
  display: flex
  justify-content: center
  padding-top: 30px
  border-top: solid 1px $borderDark1

.views-bulletin-layout__dialog .el-dialog
  border-radius: $pageBorderRadius
  &__header
    border-top-left-radius: $pageBorderRadius
    border-top-right-radius: $pageBorderRadius
    background-color: $bgDark3
  &__title
    color: $mainFontColor
    font-size: map-get($fontSize,large)
    font-weight: bold
    line-height: 32px
  &__close
    font-size: 25px
    font-weight: bolder
    color: $subFontColor
  &__body
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    font-size: map-get($fontSize,small)
    padding: 35px 40px

.views-bulletin-layout__dialog__image-wrapper
  display: flex
  justify-content: center
  margin-bottom: 20px
  width: 100%
  height: 100%

.views-bulletin-layout__dialog__image
  width: 100%
  max-width: 420px
  height: 100%
  object-fit: cover
</style>
